import { label, tip, min, max, step } from '../field-objects/overRideFields'

export const editFieldsForm = {
  label,
  tip,
  min,
  max,
  step
}
